import { render, staticRenderFns } from "./HeadingWidget.vue?vue&type=template&id=6f2c7682&scoped=true&"
import script from "./HeadingWidget.vue?vue&type=script&lang=js&"
export * from "./HeadingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c7682",
  null
  
)

export default component.exports